var map = {
	"./001-funfair.png": 78,
	"./002-makeover.png": 79,
	"./003-coat.png": 80,
	"./004-student.png": 81,
	"./005-indoor-antenna.png": 82,
	"./006-athlete.png": 83,
	"./007-armchair.png": 84,
	"./008-healthy.png": 85,
	"./009-house.png": 86,
	"./010-necklace.png": 87,
	"./011-attached.png": 88,
	"./012-tent.png": 89,
	"./013-measuring-tape.png": 90,
	"./014-robot.png": 91,
	"./015-baby.png": 92,
	"./016-question.png": 93,
	"./shopping_bag.jpg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;